import React, { FC, useState } from 'react';
import { Box, Grid, Container } from '@mui/material';
import StyledBox, {
  StyledFilterDropdown,
} from 'views/rebranded-module/events-module/MotorcycleEventsViewV2/components/EventsAndFilterSection/EventsAndFilterSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  EventAndRidesCardV2,
  LazyLoadWithDataCountsV2,
  NoAvailableData,
} from 'views/rebranded-module/common/components';
import PATHS from 'lib/navigation/paths';
import { DEFAULT_EVENTS_COUNT } from 'views/rebranded-module/events-module/MotorcycleEventsViewV2/utils/Constants';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';

interface EventsAndFilterProps {
  filterLists: any;
  events: any;
  handleChangeEventsOrLocationsType: (e: any, type: string) => void;
  handleEventCardCLick: (id: number | string, slug: string) => void;
}

const EventsAndFilterSection: FC<EventsAndFilterProps> = (props) => {
  const {
    filterLists,
    handleChangeEventsOrLocationsType,
    events,
    handleEventCardCLick,
  } = props;
  const content = useContent('EventsListingPage');
  const appNavigator = useAppNavigator();
  const [eventsCount, setEventsCount] = useState(DEFAULT_EVENTS_COUNT);
  const handleClearAllFilters = () => {
    appNavigator.push(PATHS.motorcycleEvents.index());
  };
  return (
    <StyledBox>
      <Container maxWidth="xl" className="EFSContent">
        <Box className="EFSFiltersContainer">
          {filterLists.map((filterLists) => (
            <StyledFilterDropdown
              className="EFSEventInput"
              filterList={filterLists}
              handleChange={handleChangeEventsOrLocationsType}
              icon={filterLists.icon}
              isLast={filterLists.isLast}
              MenuPropsOverride={{
                PaperProps: {
                  sx: { width: 'auto' },
                },
              }}
            />
          ))}
        </Box>
        {events.length > 0 ? (
          <>
            <Grid
              container
              columnSpacing={6}
              rowSpacing={{ lg: 8, md: 5, xs: 5 }}>
              {events.slice(0, eventsCount).map((event) => (
                <Grid item xs={12} md={12} lg={6} key={event.id}>
                  <Box 
                  className="EFSCardBox"
                    onClick={() => {
                      handleEventCardCLick(event.id, event.slug);
                    }}>
                    <EventAndRidesCardV2
                      isFeatured={event.featured}
                      title={event.name}
                      address={event.address_line}
                      startDate={event.interval.split('-')[0]}
                      endDate={event.interval.split('-')[1]}
                      startDateDay={event.date.day}
                      startDateMonth={event.date.month}
                      image={event.image?.medium_url}
                      path={PATHS.motorcycleEvents.slug(event.slug)}
                      showBtn
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
            <Box my={6}>
              <LazyLoadWithDataCountsV2
                dataCount={eventsCount}
                dataLength={events?.length}
                defaultDataCount={DEFAULT_EVENTS_COUNT}
                setDataCount={setEventsCount}
              />
            </Box>
          </>
        ) : (
          <Box my={16}>
            <NoAvailableData
              title={content.noEventsFoundTitle}
              description={content.noEventsFoundDesc}
              handleClick={handleClearAllFilters}
              buttonText={content.backBtnLabel}
              icon="/imgs/Rebranding/common/no_events.png"
            />
          </Box>
        )}
      </Container>
    </StyledBox>
  );
};

export { EventsAndFilterSection };
